var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3.99951C6 1.79037 7.79086 -0.000488281 10 -0.000488281H14C16.2091 -0.000488281 18 1.79037 18 3.99951H23C23.5523 3.99951 24 4.44723 24 4.99951C24 5.5518 23.5523 5.99951 23 5.99951H21.9513L21.3363 18.2991C21.1766 21.4924 18.541 23.9995 15.3438 23.9995H8.65624C5.459 23.9995 2.82339 21.4924 2.66373 18.2991L2.04875 5.99951H1C0.447715 5.99951 0 5.5518 0 4.99951C0 4.44723 0.447715 3.99951 1 3.99951H6ZM4.05125 5.99951L4.66124 18.1993C4.76768 20.3281 6.52475 21.9995 8.65624 21.9995H15.3438C17.4752 21.9995 19.2323 20.3281 19.3388 18.1993L19.9487 5.99951H4.05125ZM16 3.99951H8C8 2.89494 8.89543 1.99951 10 1.99951H14C15.1046 1.99951 16 2.89494 16 3.99951ZM9 9.99951C9.55229 9.99951 10 10.4472 10 10.9995V15.9995C10 16.5518 9.55229 16.9995 9 16.9995C8.44772 16.9995 8 16.5518 8 15.9995V10.9995C8 10.4472 8.44772 9.99951 9 9.99951ZM15 9.99951C15.5523 9.99951 16 10.4472 16 10.9995V15.9995C16 16.5518 15.5523 16.9995 15 16.9995C14.4477 16.9995 14 16.5518 14 15.9995V10.9995C14 10.4472 14.4477 9.99951 15 9.99951Z",
    fill: "#0B907B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewDeleteIcon);
export default __webpack_public_path__ + "static/media/new-delete-icon.01feedbdc4ef47f9f8080bdb693c84ef.svg";
export { ForwardRef as ReactComponent };